import { useMemo, useState } from "react";
import FilterColorful from "../../../Components/Buttons/FilterColorful";
import FilterOverflowRow from "../../../Components/Buttons/FilterOverflowRow";
import { isoToJalali } from "../../../helper/isoToJalali";
import TransactionsGrid from "./TransactionsGrid";
import TransactionsTable from "./TransactionsTable";

const PAYMENT_TYPE_LABELS = {
  manual: "کیف کریپتو",
  nowpayment: "درگاه کریپتو",
  directpay: "درگاه ریالی",
};

const formatTransactionAmount = (item) => {
  if (item.currency === "IRR") {
    return `${Number(item.amount_irr).toLocaleString()} ریال`;
  }

  return `$${Number(Number(item.amount).toFixed(2)).toLocaleString()}`;
};

export default function Transactions({ historyData, accLoading }) {
  const [activeFilters, setActiveFilter] = useState([true, true, true]);
  const [activeView] = useState(() =>
    window.innerWidth >= 480 ? [false, true] : [true, false],
  );

  const transactionRows = useMemo(
    () =>
      Array.isArray(historyData)
        ? historyData.map((item) => {
            const status =
              item.status === "completed"
                ? "done"
                : item.status === "pending"
                  ? "stall"
                  : "failed";

            return {
              uuid: item.code,
              transactionType:
                item.transaction_type === "payment" ? "deposit" : "withdraw",
              paymentType:
                item.transaction_type === "payment"
                  ? PAYMENT_TYPE_LABELS[item.payment_type] || "-"
                  : "-",
              requestDate: isoToJalali(item.created_at),
              volume: formatTransactionAmount(item),
              accountID: item.account_code,
              doneDate:
                item.status === "completed"
                  ? isoToJalali(item.updated_at)
                  : "-",
              status,
            };
          })
        : [],
    [historyData],
  );

  const filteredRows = useMemo(
    () =>
      transactionRows.filter((row) => {
        if (row.status === "done") return activeFilters[0];
        if (row.status === "stall") return activeFilters[1];
        if (row.status === "failed") return activeFilters[2];
        return false;
      }),
    [activeFilters, transactionRows],
  );

  const showEmptyState =
    !accLoading && Array.isArray(historyData) && historyData.length === 0;

  return (
    <div className="w-full p-5 flex flex-col gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <FilterOverflowRow>
        <FilterColorful
          SVGName="tick"
          text="تکمیل شده"
          className="w-24 shrink-0"
          color={activeFilters[0] ? "green" : "gray"}
          activeFilter={activeFilters}
          setActiveFilter={setActiveFilter}
          filterIndex={0}
        />
        <FilterColorful
          SVGName="stall"
          text="در انتظار"
          className="w-24 shrink-0"
          color={activeFilters[1] ? "yellow" : "gray"}
          activeFilter={activeFilters}
          setActiveFilter={setActiveFilter}
          filterIndex={1}
        />
        <FilterColorful
          SVGName="failed"
          text="رد شده"
          className="w-24 shrink-0"
          color={activeFilters[2] ? "red" : "gray"}
          activeFilter={activeFilters}
          setActiveFilter={setActiveFilter}
          filterIndex={2}
        />
      </FilterOverflowRow>

      {activeView[0] && (
        <TransactionsGrid
          rows={filteredRows}
          accLoading={accLoading}
          showEmptyState={showEmptyState}
        />
      )}
      {activeView[1] && (
        <TransactionsTable
          rows={filteredRows}
          accLoading={accLoading}
          showEmptyState={showEmptyState}
        />
      )}
    </div>
  );
}
